<template>
    <div class="vipbox">
        <div class="covers"></div>
        <div class="vip_info" @click="Close">
            <h2>{{$t('vip.title')}}</h2>
            <img src="../../assets/VIP.jpg" alt="" class="vippic" />
            <h2>{{ $t('vip.info') }}</h2>
            <p v-if="lang==1">消费满{{UserInfo.LevelBalance}}元或者订单累计达{{UserInfo.LevelNumber}}单,升级为{{UserInfo.NewCusLevel==3?"普通":UserInfo.NewCusLevel==5?"金卡":UserInfo.NewCusLevel==9?"铂金":''}}会员。</p>
            <p v-else>Achieve Gold Member status in {{UserInfo.LevelBalance}}RMB or {{UserInfo.LevelNumber}} Orders</p>

            <p v-if="lang==1" class="click">点击此处了解更多会员权益</p>
            <p v-else >To learn more about our EperClub and it's benefits, <span :class="lang!=1 ? 'click_info' : ''">{{$t('vip.click_this')}}</span></p>
        </div>
    </div>
</template>
<script>
// NewCusLevel  将要达到的下一等级ID  3普通用户，5金卡用户，9铂金用户
  export default {
    name: "Vipbox",
    data() {
      return {
        UserInfo:[],
        lang:2
      };
    },
    created() {
        this.lang = localStorage.getItem("lang") ? localStorage.getItem("lang") : 2;
        this.GetCusGrade()
    },
    mounted() {

    },
    methods: {
        Close(){
            this.$emit('closeVip', false)
            document.body.style.overflow='';//出现滚动条
        },
        GetCusGrade(){
            this.$store.dispatch("GetCusGrade",{
                Token:localStorage.getItem('Token'),
                Channel:'epermpc',
                LanguageType:localStorage.getItem('lang')
            }).then(res=>{
                if(res.Code==200){
                    this.UserInfo=res.Data;
                }
            })
        }
    }
  }

</script>
<style lang="scss" scoped>
  @import "../../style/base.scss";
  @import "../../style/color.scss";
.vipbox{
    .covers{
        position: fixed;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        background-color: #000;
        opacity: 0.76;
        z-index: 999990;
    }
    .vip_info{
        position: fixed;
        top: 50%;
        left: 50%;
        width: 603px;
        height: 610px;
        background-color: #fff;
        z-index: 999999;
        transform: translate(-50%,-50%);
        border-radius: 40px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        padding: 43px 73px;
        text-align: center;
        pointer-events: none;
        
        h2{
            font-size: 24px;
            font-family: "EperFontLight";
        }
        p{
            font-size: 23px;
            font-family: "EperFontLight";
            
            .click_info{
                text-decoration: underline;
                cursor: pointer;
            }
        }
        .click{
            pointer-events: auto;
            cursor: pointer;
            }
        .vippic{
            width: 238px;
            height: 238px;
            display: block;
        }
    }
    .vip_info::after{
        content: "";
        background: url("../../../static/close.png") no-repeat ;
        background-size:38px 38px;
        width: 38px;
        height: 38px;
        position: absolute;
        right: 20px;
        top: 20px;
        z-index: 999999;
        pointer-events: auto;
        cursor:pointer;
    }
}
</style>
  


// WEBPACK FOOTER //
// src/components/public/Vipbox.vue